import type { FilterPopoverProps } from "@js/apps/employer/components/filter-popover";
import { FilterPopover } from "@js/apps/employer/components/filter-popover";

import styles from "./styles.module.scss";

export const BidListFilterPopover = ({
  children,
  ...rest
}: FilterPopoverProps) => {
  return (
    <FilterPopover
      {...rest}
      variant="violet"
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      anchorClassName={styles.anchor}
    >
      {children}
    </FilterPopover>
  );
};
